<template>
<div id="layout">
	<menu id="drawer" :class="{ drawer: Store.drawer }" @click="Store.menuClose()">
		<div>
			<h1 style="margin: 1rem; text-align: center;">
				<img src="/app/icons/favicon-128.png" style="vertical-align: middle; width: 4rem"/>
				Writer
			</h1>
			<a class="mdi mdi-file-plus-outline" @click="fileNew()">{{ Store.l.new_doc }}</a>
			<router-link class="mdi mdi-folder-open-outline" to="/file/open">{{ Store.l.open_doc }}</router-link>
			<hr/>
			<router-link class="mdi mdi-cog" to="/settings">{{ Store.l.settings }}</router-link>
			<a class="mdi mdi-open-in-new" target="_blank" href="https://writer.kaisa.it/">{{ Store.l.website }}</a>
			<hr/>
			<a class="mdi mdi-export" @click="exportJSON()">{{ Store.l.export }}</a>
			<router-link class="mdi mdi-import" to="/file/import">{{ Store.l.import }}</router-link>
			<a class="mdi mdi-export" @click="alert('ToDo')">{{ Store.l.export_epub }}</a>
		</div>
	</menu>
	<main>
		<router-view></router-view>
	</main>
	<Messages/>
	<aside v-show="Store.meta.serverDirty" id="saveOverlay" @click="Store.docSave()"><i class="mdi mdi-content-save-outline"></i></aside>
	<footer>
		<div>
			<router-link to="/" :class="{ active: (this.tab == 'setting') }"><i class="mdi mdi-book-open-variant"></i><br/>{{ Store.l.book }}</router-link>
			<router-link to="/write" :class="{ active: (this.tab == 'write') }"><i class="mdi mdi-keyboard"></i><br/>{{ Store.l.write }}</router-link>
			<router-link to="/track" :class="{ active: (this.tab == 'track') }"><i class="mdi mdi-view-dashboard"></i><br/>{{ Store.l.track }}</router-link>
		</div>
	</footer>
</div>
</template>

<style lang="scss">

@import './include/style.scss';

#drawer {
	margin: 0;
	z-index: 10;

	div {
		position: fixed;
		z-index: 10;
		top: 0;
		left: -20rem;
		width: 20rem;
		height: 100vh;
		background: var(--color-foreground);
		overflow: auto;
		margin: 0;
		padding: 0;
		box-shadow: var(--shadow-2);
		transition: left .3s;
	}

	a {
		padding: .5rem 1rem;
		display: block;
		&:hover {
			background: var(--color-background2);
		}
		&::before {
			margin-right: .5rem;
		}
	}

	&::before {
		content: "";
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: black;
		visibility: hidden;
		opacity: 0;
		transition: opacity .3s, visibility 0s linear 0.5s;
	}

	&.drawer {
		div {
			left: 0;
		}
		&::before {
			visibility: visible;
			opacity: .6;
			transition-delay: 0s;
		}
	}
}

footer {
	background: var(--color-foreground);
	text-align: center;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	box-shadow: var(--shadow-1);

	div {
		display: flex;
		justify-content: center;
		max-width: 36rem;
		margin: auto;
	}

	a {
		flex: auto;
		padding: .5rem 0;
		border-style: solid;
		border-width: 2px 0 0 0;
		border-color: transparent;
		color: var(--color-text);
		text-decoration: none;

		&:hover,
		&.active {
			background: var(--color-background2);
			border-color: #ff7e00;
		}
	}
}


</style>

<script>

import Store from '@/Store.js'

import Messages from "@/components/Messages.vue"

import { WDocument } from './include/models.js'

export default {
	components: { Messages },
	data: () => ({
		Store,
		tab: "setting",
	}),
	watch: {

		"Store.doc": {
			handler() {
				if (this.Store.initialize) {
					this.Store.initialize = false;
				} else {
					this.Store.dirty = true;
					if (Store.meta.serverUUID) this.Store.meta.serverDirty = true;
				}
			},
			deep: true,
		},

		"Store.settings": {
			handler() {
				document.body.className = this.Store.settings.theme;
				this.Store._saveSettings();
			},
			deep: true,
		},

		"Store.exception"() {
			if (!Store.exception) return;

			if (typeof Store.exception === "object") {
				this.$router.push(Store.exception);
			} else if (Store.exception === "home") {
				this.$router.push("/");
			} else if (Store.exception === "conflict") {
				this.$router.push("/conflict");
			} else if (Store.exception === "outdated") {
				this.$router.push("/outdated");
			}

			Store.exception = null;
		},

		$route(to) {
			if (to.path === "/") {
				this.tab = "setting";
			} else if (to.path.match(/^\/track/)) {
				this.tab = "track";
			} else if (to.path.match(/^\/(write|section)/)) {
				this.tab = "write";
			} else {
				this.tab = null;
			}
		}
	},

	mounted() {
		document.getElementById("splash").remove();
	},

	methods: {
		exportJSON() {
			let el = document.createElement('a');
			el.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.Store.doc)));
			el.setAttribute('download', this.Store.doc.uuid+".json");
			el.style.display = 'none';
			document.body.appendChild(el);
			el.click();
			document.body.removeChild(el);
			this.Store.menuClose();
		},

		fileNew() {
			this.Store.docNew();
			this.$router.push("/");
			this.Store.toggleMenu();
			this.initialize = true;
		},

	}
}
</script>
